import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "../Login/Login";
import Signout from "../Login/SignOut.js";
import IConnectHome from "../Landing/IConnectHome.js";
import Logout from "../Landing/Logout.js";

const MainSection = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<IConnectHome />} />
        <Route path="/SignOut" element={<Signout />} />
        <Route path="/Logout" element = { <Logout /> } />
      </Routes>
    </Router>
  );
};
export default MainSection;
